import React from 'react';
import { useTranslation } from 'react-i18next';
import { Descriptions, Tag, Typography, Card } from 'antd';
import { formatDateTime } from '@utils/dateTime';

const { Text } = Typography;

const STATUS_COLOR = (status) => {
  if (!status) return 'default';
  if (status >= 200 && status < 300) return 'success';
  if (status >= 400 && status < 500) return 'warning';
  if (status >= 500) return 'error';
  return 'default';
};

const LOGGABLE_TYPE_I18N_KEY = {
  EcAccount: 'models.ec_account._',
  Merchant: 'models.merchant._',
};

// 處理 Ruby hash 格式 (=> ) 轉為 JSON 格式
const rubyHashToJson = (str) => {
  return str
    .replace(/=>/g, ':')
    .replace(/nil/g, 'null')
    .replace(/true/g, 'true')
    .replace(/false/g, 'false');
};

const JsonBlock = ({ value }) => {
  if (!value) return <Text type="secondary">-</Text>;
  let display = value;
  try {
    const str = typeof value === 'string' ? value : JSON.stringify(value);
    const normalized = rubyHashToJson(str);
    const parsed = JSON.parse(normalized);
    display = JSON.stringify(parsed, null, 2);
  } catch {
    display = typeof value === 'string' ? value : JSON.stringify(value);
  }
  return (
    <pre style={{
      background: '#f5f5f5',
      padding: 12,
      margin: 0,
      borderRadius: 4,
      fontSize: 12,
      overflow: 'auto',
      maxHeight: 400,
      whiteSpace: 'pre-wrap',
      wordBreak: 'break-all',
    }}>
      {display}
    </pre>
  );
};

export default function ThirdPartyApiLogShow({ log }) {
  const { t } = useTranslation();

  if (!log) return null;

  return (
    <div>
      <Card style={{ marginBottom: 16 }}>
        <Descriptions column={4} bordered size="small">
          <Descriptions.Item label={t('common.created_at')} span={2}>
            {formatDateTime(log.created_at)}
          </Descriptions.Item>
          <Descriptions.Item label={t('models.third_party_api_log.duration')} span={2}>
            {log.duration_ms?.toFixed(2)} ms
          </Descriptions.Item>
          <Descriptions.Item label={t('models.third_party_api_log.method')} span={1}>
            <Tag>{log.request_method}</Tag>
          </Descriptions.Item>
          <Descriptions.Item label={t('models.third_party_api_log.status')} span={1}>
            <Tag color={STATUS_COLOR(log.response_http_status)}>{log.response_http_status}</Tag>
          </Descriptions.Item>
          <Descriptions.Item label={t('models.third_party_api_log.loggable')} span={2}>
            <Tag color="blue">
              {t(LOGGABLE_TYPE_I18N_KEY[log.loggable_type] || log.loggable_type, { defaultValue: log.loggable_type })}
            </Tag>
          </Descriptions.Item>
          <Descriptions.Item label={t('models.third_party_api_log.path')} span={4}>
            <Text copyable style={{ wordBreak: 'break-all', fontSize: 12 }}>
              {log.request_path}
            </Text>
          </Descriptions.Item>
        </Descriptions>
      </Card>

      <Card
        title={t('models.third_party_api_log.request')}
        style={{ marginBottom: 16 }}
        size="small"
      >
        <JsonBlock value={log.request} />
      </Card>

      <Card
        title={t('models.third_party_api_log.response')}
        size="small"
      >
        <JsonBlock value={log.response} />
      </Card>
    </div>
  );
}
